import React from 'react'
import Paneerroll from "../assets/img/Crunchies/Paneer-kathi-Roll-Featured-1.jpg"
import vegRoll from "../assets/img/Rolls/vegRolls.jpg"
import eggRoll from "../assets/img/Rolls/eggRolls.jpg"
import chknRoll from "../assets/img/Rolls/peppy-chicken-roll.png"

function Rolls() {
  return (
    <div>

<section id="our">
 <div className="container">
  <div className="row">
   <div className="col-sm-12" data-aos="fade-right"
     data-aos-easing="linear"
     data-aos-duration="1500">
    <div className="our_1">
	<br/>
    </div>
	<div className="col-sm-3">
	 <div className="our_2">
	  <div className="ih-item square effect13 left_to_right"><a href='javascript:void(0)'>
	  <div className="img" style={{height:"280px", width:"100%"}}><img src={vegRoll} alt="img"/></div>
	  <div className="info">
		<h3>Regular:"₹ 79.00"</h3>
	  </div></a></div>
	 </div>
	 <div className="our_3">
	  <h4 className="text-center"><a href='javascript:void(0)'>Veg Roll</a></h4>
	 </div>
	</div>
	
	<div className="col-sm-3">
	 <div className="our_2">
	  <div className="ih-item square effect13 left_to_right"><a href='javascript:void(0)'>
	  <div className="img" style={{height:"280px", width:"100%"}}><img src={eggRoll} alt="img"/></div>
	  <div className="info">
    <h3>Regular:"₹ 89.00"</h3>
	  </div></a></div>
	 </div>
	 <div className="our_3">
	  <h4 className="text-center"><a href='javascript:void(0)'>Egg Roll</a></h4>
	 </div>
	</div>
    <div className="col-sm-3">
	 <div className="our_2">
	  <div className="ih-item square effect13 left_to_right"><a href='javascript:void(0)'>
	  <div className="img" style={{height:"280px", width:"100%"}}><img src={Paneerroll} alt="img"/></div>
	  <div className="info">
    <h3>Regular:"₹ 99.00"</h3>
	  </div></a></div>
	 </div>
   <div className="our_3">
	  <h4 className="text-center"><a href='javascript:void(0)'>Paneer Roll</a></h4>
	 </div>
	</div>
  <div className="col-sm-3">
	 <div className="our_2">
	  <div className="ih-item square effect13 left_to_right"><a href='javascript:void(0)'>
	  <div className="img" style={{height:"280px", width:"100%"}}><img src={eggRoll} alt="img"/></div>
	  <div className="info">
    <h3>Regular: "₹ 109.00"</h3>
	  </div></a></div>
	 </div>
   <div className="our_3">
	  <h4 className="text-center"><a href='javascript:void(0)'>Chicken Roll</a></h4>
	 </div>
	</div>
    </div>
  </div>
 </div>
</section>

    </div>
  )
}

export default Rolls